import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const solutions = [
  { title: "Manufacturing ERP", desc: "Production planning, inventory control, and quality management in one system." },
  { title: "Inventory Control", desc: "Real-time stock tracking with automated reorder points and supplier management." },
  { title: "Supply Chain AI", desc: "Demand forecasting, logistics optimization, and supplier performance analytics." },
  { title: "Shop Floor Monitoring", desc: "IoT-connected dashboards for real-time production monitoring and OEE tracking." },
];

const Manufacturing = () => (
  <StitchFeaturePage
    label="INDUSTRIES / MANUFACTURING"
    title="Operations ERP for"
    titleAccent="shop floor and boardroom."
    subtitle="Custom ERP, inventory intelligence, and AI-powered supply chain operations for manufacturers and MSMEs."
    features={solutions}
    ctaLabel="BUILD FOR MANUFACTURING"
  />
);

export default Manufacturing;
